import { styled } from "@mui/material";
import BarekamText from "../../../components/text";
import { Swiper, SwiperSlide } from 'swiper/react';

export const CarouselContainer = styled("div")`
  width: 100%;
  height: 540px;
`;

export const SlideContent = styled(Swiper) <{ bgColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: ${(props) => props.bgColor || "#fff"};
  color: #fff;
  font-size: 24px;
  font-weight: bold;
`;

export const Copy = styled("div")`
  position: relative;
  z-index: 1;
  max-width: 660px;
  margin-left: 140px;

  @media screen and (max-width: 768px) {
    max-width: 400px;
    margin-left: 14px;
  }
`;

export const BigTextWrapper = styled(BarekamText)`
    margin-bottom: 20px;
    line-height: 50px !important;

    @media screen and (max-width: 768px) {
      font-size: 28px !important;
      line-height: 38px !important;;
    }
`;

export const SlideItem = styled(SwiperSlide)`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: 540px;
  border-radius: 15px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    object-fit: cover;
  }
`;
